import { HubConnectionBuilder, LogLevel, HubConnection, HttpTransportType  } from '@microsoft/signalr';

const isDevelopment = process.env.NODE_ENV === 'development';
// console.log("isDevelopment", isDevelopment);
if (isDevelopment) {
  (window as any).process = { env: { NODE_TLS_REJECT_UNAUTHORIZED: "0" } };
}

let connection: HubConnection | null = null;

export const initializeSignalRConnection = async (token: string, signal?: AbortSignal): Promise<HubConnection> => {
  if (connection) return connection;

  connection = new HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_API_BASE_URL}/signalr-chat`, {
      accessTokenFactory: () => token,
      transport: HttpTransportType.WebSockets,
      skipNegotiation: true
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: retryContext => {
        if (retryContext.elapsedMilliseconds < 60000) {
          return 5000; // Retry every 5 seconds for first minute
        }
        return 60000; // Then retry every minute after
      }
    })
    .configureLogging(LogLevel.Debug)
    .build();

    const abortHandler = () => {
    connection?.stop().catch(() => {});
  };
  signal?.addEventListener('abort', abortHandler);

    try {
      // console.log("Starting SignalR connection..."); 
      signal?.removeEventListener('abort', abortHandler);
        await connection.start();
       
        return connection;
    } catch (error) {
      signal?.removeEventListener('abort', abortHandler);
      if (signal?.aborted) {
      throw new DOMException("Connection was aborted", "AbortError");
    }
    // await connection.stop();
    throw error;
      // console.error('Error starting SignalR connection:', error);
      // setTimeout(() => initializeSignalRConnection(token), 50);
    }
  
};

// export const getConnection = () => connection;
export const disconnectSignalR = async (connection: any) => {
  if (!connection) return;
  
  try {
    // Only attempt to stop if connection isn't already disconnected
    if (connection.state !== "Disconnected") {
      await connection.stop();
    }
  } catch (error) {
    if (typeof error === "object" && error !== null && "message" in error && typeof (error as any).message === "string") {
      if (!(error as any).message.includes("already in the disconnected state")) {
        console.error("Disconnection error:", error);
      }
    } else {
      console.error("Disconnection error:", error);
    }
  }
};